export default {
	// Endpoints — no leading slash: baseURL already ends in "/api/", axios
	// concatenates baseURL + endpoint verbatim (no normalization), so a
	// leading slash here produced "/api//web/auth/login" — a double slash
	// that 404s on this server's Laravel router (some other servers
	// silently normalize "//" in the path; this one doesn't).
	loginEndpoint: "web/auth/login",
	registerEndpoint: "jwt/register",
	refreshEndpoint: "jwt/refresh-token",
	logoutEndpoint: "auth/logout",

	// This will be prefixed in authorization header with token
	// e.g. Authorization: Bearer <token>
	tokenType: "Bearer",

	// Value of this property will be used as key to store JWT token in storage
	storageTokenKeyName: "accessToken",
	storageRefreshTokenKeyName: "refreshToken",
};
